import { Checkbox as UICheckbox } from "@components/ui/checkbox";
import React from "react";
import Tooltip from "@ui/external/components/tooltip";

type Props = {
  label?: string;
  subtitle?: string;
  [key: string]: any;
};

const Checkbox: React.FC<Props> = ({ label, subtitle, ...props }) => {
  return (
    <>
      <label {...props} className="flex cursor-pointer  items-center gap-2">
        <UICheckbox className="me-2" {...props} />
        <Tooltip description={label}>
          <p className="text-black max-w-[280px] truncate">{label}</p>
        </Tooltip>
      </label>
    </>
  );
};

export { Checkbox };
